import { Component, OnInit } from '@angular/core';
import { MembersAssociationsStatsStore } from '../../../../../common-page-components/stores/entities-store/members-associations-stats-store';
import { HttpClient } from '@angular/common/http';
import { of, Observable } from 'rxjs';
import { map, filter, catchError, tap, first } from 'rxjs/operators';
import { MembersSearchFiltersService } from '../../services/members-search-filters.service';
import { IRegionComboData } from '../../../../../common-page-components/stores/filters-store/filters-store';
import { Router } from '@angular/router';
import { INews } from 'src/app/common-page-components/news-panel/news-panel.component';
import { environment } from '@environments/environment';

@Component({
  selector: 'app-bootstrap-members-search',
  templateUrl: './bootstrap-members-search.component.html',
  styleUrls: ['./bootstrap-members-search.component.scss']
})
export class BootstrapMembersSearchComponent implements OnInit {
  memberStats: MembersAssociationsStatsStore;
  news: Array<INews>;
  constructor(http: HttpClient, private router: Router, public filter_service: MembersSearchFiltersService) {
    this.memberStats = new MembersAssociationsStatsStore(http, []);
    this.memberStats.requestData({}, false).subscribe();
    http.get(environment.news_api.members).pipe(catchError(e => of([]))).subscribe((next: any) => {
      this.news = next as any;
    })
  }

  ngOnInit() {
  }

  /**
   * Return the number of associations
   *
   * @returns {number}
   * @memberof BootstrapMembersSearchComponent
   */
  getNumberOfAssociations(): Observable<number> {

    return this.memberStats.observableData.pipe(filter(a => a != null), map(a => (a as any).MemberAssociationNumber));
  }

  /**
   * Get count of associations
   *
   * @readonly
   * @memberof BootstrapMembersSearchComponent
   */
  get count() {
    return (this.memberStats.data as any).MemberAssociationNumber;
  }


  /**
   * Get continent names
   *
   * @readonly
   * @memberof BootstrapMembersSearchComponent
   */
  get continentNames() {
    return this.filter_service.regionCombo
      .filterInfo.options.options_subject.asObservable()
      .pipe(map(a => a.filter(value => value.Continent !== 'All').map(a => a)))
  }

  /**
   * Get continent assets for active and not active region
   *
   * @param {string} continent
   * @returns
   * @memberof BootstrapMembersSearchComponent
   */
  getContinentAsset(continent: string) {
    return this.filter_service.regionCombo.comboData.pipe(
      map(
        a => {
          return a.Continent === continent ?
            '../../../../../../modules/custom/wa_angular/app/assets/images/assets-maps/' + continent.toLowerCase().toString() + '-active.png'
            : '../../../../../../modules/custom/wa_angular/app/assets/images/assets-maps/' + continent.toLowerCase().toString() + '.png'

        }))
  }

  /**
   * Method for generate the propertly route segent.
   *
   * @param {IRegionComboData} continent
   * @returns
   * @memberof BootstrapMembersSearchComponent
   */
  generateRouterSegmente(continent: IRegionComboData) {
    return ['/member', continent.CaCode, this.changeNameForURL(continent.CaName)];
  }

  /**
   * Helper function for replace the name of url for navigation and avoid spaces
   *
   * @param {string} name
   * @returns
   * @memberof BootstrapMembersSearchComponent
   */
  changeNameForURL(name: string) {
    return name.toLowerCase().replace(/ /g, '-');
  }

  /**
   * A method for select the continent and set active.
   *
   * @param {*} continent The continent to be selected
   * @param {boolean} shouldDeselect If the continent should be deselected.
   * @memberof BootstrapMembersSearchComponent
   */
  selectContinent(continent, shouldDeselect = false) {
    this.filter_service.regionCombo.comboData.pipe(
      first(),
      tap(a => {
        let continentSelected = continent;
        if (shouldDeselect === true && a.Continent === continent.Continent) {
          continentSelected = { Continent: 'All' };
        }
        this.filter_service.regionCombo.filterInfo.options.options_selected_subject.next(continentSelected);
      })
    ).subscribe();
  }
}
